import React from 'react';
import { Alert } from '@material-ui/lab';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  alert: {
    marginTop: '8px',
    '@media print': {
      display: 'none',
    }
  },  
  para: {
    '&:first-child': {
      marginTop: 0,
    },
    '&:last-child': {
      marginBottom: 0,
    },
  },
}));

const AmountOverCardLimitWarning: React.FunctionComponent = () => {
  const classes = useStyles();
  return (
    <Alert severity="warning" className={classes.alert}>
      <p className={classes.para}>This invoice exceeds the card payment limit therefore payment is required by BACS or alternatively you can set up Direct Debit. Please see the bank details below.</p>
      <p>
        <strong>Company Name:</strong> Zen Internet Limited
        <br />
        <strong>Account Number:</strong> 29366585
        <br />
        <strong>Sort Code:</strong> 01-07-44
      </p>
    <p className={classes.para}>If you have any queries regarding payment, please contact the customer billing team on <a href="tel:01706902003">01706 902003</a> or email <a href="mailto:customerbilling@zeninternet.co.uk">customerbilling@zeninternet.co.uk</a></p>
    </Alert>
  );
};

export default AmountOverCardLimitWarning;